/**
 * How a forge's arche settings read at a glance — shared by the Arche
 * settings card and the publish dialog, so both describe the same thing.
 */
import type { ForgePublishOptions, ForgePublishSettingsView } from '@/lib/api';

/** "Free" / "$1.50 per use", then how the arche appears. */
export function describeArcheSettings(settings: ForgePublishOptions): string[] {
  const price =
    settings.pricing.model === 'fixed'
      ? `$${(settings.pricing.priceCents / 100).toFixed(2)} per use`
      : 'Free';
  return [
    price,
    settings.isListed ? 'Listed in the Arche Store' : 'Not listed',
    ...(settings.isPublic ? ['Public access'] : []),
    ...(settings.isFullScreen ? ['Full screen'] : []),
    ...(settings.game?.isGame ? ['On the Games page'] : []),
  ];
}

/** A publish needs a name and a short description. */
export function archeSettingsComplete(settings: ForgePublishOptions): boolean {
  return settings.name.trim().length > 0 && settings.description.trim().length > 0;
}

/** The icon the arche will have after the next publish (a staged change wins). */
export function upcomingArcheIcon(view: ForgePublishSettingsView): string | null {
  const pending = view.icon.pending;
  if (pending?.state === 'set') return pending.imageRef;
  if (pending?.state === 'delete') return null;
  return view.icon.imageRef;
}
